var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3334 13.3334L10.6334 10.6334M10.6334 10.6334C11.0668 10.2 11.4105 9.68557 11.6451 9.11936C11.8796 8.55314 12.0003 7.94628 12.0003 7.33341C12.0003 6.72054 11.8796 6.11368 11.6451 5.54746C11.4105 4.98125 11.0668 4.46677 10.6334 4.03341C10.2 3.60005 9.68557 3.25628 9.11936 3.02175C8.55314 2.78722 7.94628 2.6665 7.33341 2.6665C6.72054 2.6665 6.11368 2.78722 5.54746 3.02175C4.98125 3.25628 4.46677 3.60005 4.03341 4.03341C3.15819 4.90862 2.6665 6.09567 2.6665 7.33341C2.6665 8.57115 3.15819 9.75819 4.03341 10.6334C4.90862 11.5086 6.09567 12.0003 7.33341 12.0003C8.57115 12.0003 9.75819 11.5086 10.6334 10.6334V10.6334Z",
    stroke: "currentColor",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchSmall);
export default __webpack_public_path__ + "static/media/search-small.b624ff2496b03717224f62895c9eaec3.svg";
export { ForwardRef as ReactComponent };